import { Calendar, theme } from "antd";

export const RACalendar = (onPanelChange) => {
	const { token } = theme.useToken();
	const wrapperStyle = {
		width: 300,
		border: `1px solid ${token.colorBorderSecondary}`,
		borderRadius: token.borderRadiusLG,
	};
	return (
		<div style={wrapperStyle}>
			<Calendar fullscreen={false} onPanelChange={onPanelChange} />
		</div>
	);
};
